// Import required liraries
import React from "react";

// Import styles
import "./Unauthorised.scss";

// Import Custom Component
import LayoutNone from "../../layouts/LayoutNone/LayoutNone";

// Import data/utils
import { config } from "../../config/config";

function Unauthorised() {
  return (
    <LayoutNone>
      <div className="screen-container">
        <div className="title-container">
          <i className="material-icons-outlined screen-icon">
            sentiment_very_dissatisfied
          </i>
          <h1 className="screen-title">
            {config.messages.UnauthorisedMessage}
          </h1>
        </div>
        <div className="button-container">
          <a href={`${window.location.origin}/home`}>
            <button className="button">Go to MROI-AIDE</button>
          </a>
        </div>
      </div>
    </LayoutNone>
  );
}

Unauthorised.propTypes = {};

export default Unauthorised;
